import { create } from 'zustand';
import { AuthStore } from './authStore';
import { persist } from 'zustand/middleware';

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isMfaEnabled: false,
      accessToken: null,
      refreshToken: null,
      login: (accessToken, refreshToken) =>
        set({
          isAuthenticated: true,
          isMfaEnabled: true,
          accessToken,
          refreshToken,
        }),
      setAccessToken: (accessToken) =>
        set({
          accessToken,
        }),
      logout: () =>
        set({
          isAuthenticated: false,
          isMfaEnabled: false,
          accessToken: null,
          refreshToken: null,
        }),
    }),
    {
      name: 'auth-storage',
    }
  )
);
